'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherFileText, FeatherHome, FeatherScale } from '@subframe/core';
import type { ReactNode } from 'react';
import { Badge, Button, Loader, RadioCardGroup } from '@/shared/components/ui';
import type { UseNegociacaoSelfReturn } from '../hooks';
import type { ObjetivoSelf } from '../types';
import { WizardProgressHeader } from './WizardProgressHeader';
interface ObjetivoScreenProps {
  vm: UseNegociacaoSelfReturn;
}
const OBJETIVO_ICONES: Record<ObjetivoSelf, ReactNode> = {
  desocupacao: <FeatherHome className="text-heading-dark" />,
  valores: <FeatherFileText className="text-heading-dark" />,
  clausula: <FeatherScale className="text-heading-dark" />
};
export const ObjetivoScreen = t0 => {
  const $ = _c(26);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] !== vm.wizardSteps) {
    t1 = <WizardProgressHeader steps={vm.wizardSteps} />;
    $[0] = vm.wizardSteps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-8 flex w-full max-w-[1280px] flex-col gap-2 sm:mb-12"><h1 className="text-heading-dark text-2xl font-semibold sm:text-[32px]">Para que você quer usar a Lexi?</h1><p className="text-label-muted text-base">Escolha o que melhor representa a necessidade do seu negócio.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== vm.carregandoObjetivos) {
    t3 = vm.carregandoObjetivos && <div className="flex w-full max-w-[1280px] items-center gap-3 py-8"><Loader size="medium" /><span className="text-label-muted text-sm">Carregando os objetivos...</span></div>;
    $[3] = vm.carregandoObjetivos;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = vm.objetivo ?? "";
  let t5;
  if ($[5] !== vm) {
    t5 = valor => vm.selecionarObjetivo(valor as ObjetivoSelf);
    $[5] = vm;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== vm.objetivosCatalogo) {
    t6 = vm.objetivosCatalogo.map(_temp);
    $[7] = vm.objetivosCatalogo;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <RadioCardGroup value={t4} onValueChange={t5} className="!grid w-full max-w-[1280px] grid-cols-1 gap-6 md:grid-cols-3">{t6}</RadioCardGroup>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FeatherArrowRight />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = !vm.objetivo;
  let t10;
  if ($[14] !== vm) {
    t10 = () => vm.goTo("perfil");
    $[14] = vm;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <div className="mt-10 flex w-full max-w-[1280px] justify-end sm:mt-14"><Button size="small" iconRight={t8} disabled={t9} onClick={t10}>Avançar</Button></div>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t3 || $[21] !== t7) {
    t12 = <div className="flex flex-1 flex-col items-center px-6 py-10 md:px-20 md:py-16">{t2}{t3}{t7}{t11}</div>;
    $[19] = t11;
    $[20] = t3;
    $[21] = t7;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t1 || $[24] !== t12) {
    t13 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}{t12}</div>;
    $[23] = t1;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};
function _temp(opcao) {
  return <RadioCardGroup.RadioCard key={opcao.valor} value={opcao.valor} disabled={!opcao.disponivel} className="rounded-[16px]"><div className="flex w-full items-start justify-between"><div className="flex h-10 w-10 items-center justify-center rounded-[10px] bg-neutral-50">{OBJETIVO_ICONES[opcao.valor]}</div>{!opcao.disponivel && <Badge variant="neutral">Em breve</Badge>}</div><span className="text-heading-dark text-base font-semibold">{opcao.titulo}</span><span className="text-label-muted text-sm leading-relaxed">{opcao.descricao}</span></RadioCardGroup.RadioCard>;
}